import React from 'react';

import { UnauthorizedState } from '~/app/_components';
import { useSessionStore } from '~/stores/Session';

/**
 * Direct-URL gate matching the Cards navigation gate: issuer dispute pages require the issuer
 * processing dashboard on the current platform.
 */
export const IssuerDashboardGate: React.FC<React.PropsWithChildren> = ({ children }) => {
  const currentPlatform = useSessionStore((state) => state.currentPlatform);

  if (!currentPlatform) {
    return null;
  }

  if (!currentPlatform.issuerProcessingDashboardEnabled) {
    return <UnauthorizedState />;
  }

  return <>{children}</>;
};
